import React, { FC, Fragment, useEffect } from 'react';
import { Button, Select } from '@ui';
import Icon from '@app/components/ui/icons';
import { useFieldArray, useFormContext } from 'react-hook-form';
import useTranslation from '@app/hooks/use-translation';
import NestedFieldOperators from '@app/components/ui/easy-filter/blocks/nested-field-operators';
import { OptionItem } from '@app/components/ui/select/select.type';

type OperatorsFieldPropsType = {
  teamsAndOperatorsDataForFilter?: Record<'qm_teams' | 'qm_operators', OptionItem[]>;
};
const OperatorsField: FC<OperatorsFieldPropsType> = (props) => {
  const { teamsAndOperatorsDataForFilter } = props;
  const { t } = useTranslation('components.filter');

  const { control, setValue, watch } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'operators',
  });
  useEffect(() => {
    (fields.at(-1) as any)?.value?.length >= 1 && append({ type: 'qm_operators', value: [] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function appendField() {
    append({ type: 'qm_operators', value: [] });
  }

  return (
    <ul className={'flex flex-col px-[32px] '}>
      {!fields.length && (
        <Button fill="outlined" label={t('add_operators_button')} onClick={() => appendField()} />
      )}
      {fields?.map((item, index) => (
        <Fragment key={item.id}>
          {index > 0 && (
            <div
              className={
                'h-[17px] w-full flex items-center justify-center text-[14px] leading-[17px] font-[400] text-4color'
              }
            >
              {t('and')}
            </div>
          )}
          <li className="flex items-center py-4 relative bg-defaultBg rounded-[12px] border-solid border-l-[2px] border-speech_analitics px-[24px]">
            <div className={'flex items-start justify-center gap-[16px]'}>
              <div className={'w-[360px]'}>
                <Select
                  options={[
                    { title: t('operators'), value: 'qm_operators' },
                    { title: t('teams'), value: 'qm_teams' },
                  ]}
                  dropWidth={356}
                  defaultValue={watch(`operators[${index}].type`)}
                  onChange={(val) => setValue(`operators[${index}].type`, val)}
                  // onChange={(value) => onChangeParams(value, index)}
                  // options={getParamsSelectOptions()}
                  dropTop={index >= 2}
                />
              </div>
              <div className={'w-[120px] flex items-center justify-center'}>=</div>
              <NestedFieldOperators
                nestIndex={index}
                options={teamsAndOperatorsDataForFilter?.[watch(`operators[${index}].type`)]}
                appendField={appendField}
                fieldsLength={fields.length}
              />
              {/*<NestedField*/}
              {/*  getConditionOptionsWhenMoreThatOneValue={getConditionOptionsWhenMoreThatOneValue}*/}
              {/*  getConditionsSelectOptions={getConditionsSelectOptions}*/}
              {/*  appendFilter={append}*/}
              {/*  nestIndex={index}*/}
              {/*  keysForFiltering={keysForFiltering}*/}
              {/*/>*/}
            </div>
            <div className={'cursor-pointer absolute right-[-25px]'}>
              <Icon
                name="TrashIcon"
                className="!text-basic_red"
                size={14}
                onClick={() => remove(index)}
              />
            </div>
          </li>
        </Fragment>
      ))}
    </ul>
  );
};

export default OperatorsField;
